import { api } from "../../api/client";

export function getCameras() {
  return api.get("/admin/cameras");
}

export function createCamera(camera) {
  return api.post("/admin/cameras", camera);
}

export function updateCamera(id, camera) {
  return api.put(`/admin/cameras/${id}`, camera);
}

export function deleteCamera(id, sessionId) {
  return api.delete(`/admin/cameras/${id}`, { data: { session_id: sessionId } });
}
